import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'fieldsetParcelsLabel',
  standalone: true
})
export class FieldsetParcelsLabelPipe implements PipeTransform {

  transform(value: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case value?.applicationSubject === 'Lokalizacji obiektu budowlanego': {
        return 'Działki, na których zlokalizowany jest obiekt budowlany';
      }
      case value?.applicationSubject === 'Lokalizacji reklamy': {
        return 'Działki, na których zlokalizowana jest reklama';
      }
      case value?.applicationSubject === 'Lokalizacja reklamy posadowionej na obiekcie budowlanym': {
        return 'Działki, na których zlokalizowana jest reklama posadowiona na obiekcie budowlanym';
      }
      default: {
        return 'Działki';
      }
    }
  }

}
